export default "__VITE_ASSET__Td6XCksR__"